
import { trackLoginImpression } from "@/plugins/hwtag/events";
export default {
    name: 'authorIndex',
    props: ['source', 'index'],
    data() {
        return {
            asyncSource: this.source
        }
    },
    mounted() {

    },
    watch: {

    },

    methods: {

        openLoginWithSource(source) {
            const useNewLogin = this.$store.state.siteConfig && this.$store.state.siteConfig.DialogPassportSwitch == '1';
            if (useNewLogin) {
                this.$store.commit('OPEN_AUTH_MODAL', { tab: 'login', redirectToUserCenter: false, source });
            } else {
                this.$jumpTerminus(1);
            }
        },
        async focusOn(id) {
            if (!this.$store.state.isLogin) {
                trackLoginImpression('曝光', '用户', 'follow', {}, 'gallery');
                this.openLoginWithSource({
                    elementTypeName: '用户',
                    clickName: 'follow',
                    loginChannel: 'gallery',
                });
                return;
            }
            //关注用户
            let res = await this.$global.doFollow({ "fid": id })
            res.code == '200' ? (this.asyncSource.is_follow = 1, this.$message(res.msg)) : ''
        },
        async unsubscribe(id) {
            //取消关注用户
            let res = await this.$global.unFollow({ "fid": id })
            res.code == '200' ? (this.asyncSource.is_follow = 0, this.$message(res.msg)) : ''
        },
        jumpUser(id) {
            let routeData = this.$router.resolve({ path: `/user/${id}` });
            window.open(routeData.href, '_blank');

        }
    }
}
